import { render, staticRenderFns } from "./listaNotas.vue?vue&type=template&id=00f5e5c9"
import script from "./listaNotas.vue?vue&type=script&lang=js"
export * from "./listaNotas.vue?vue&type=script&lang=js"
import style0 from "./listaNotas.vue?vue&type=style&index=0&id=00f5e5c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports